import { z } from "zod";
import { AppKeySchema } from "./entitlement";

export const CalendarProjectionPlacementSchema = z.discriminatedUnion("mode", [
  z.object({ mode: z.literal("point"), at: z.string().datetime(), allDay: z.boolean() }),
  z.object({ mode: z.literal("deadline"), dueAt: z.string().datetime(), allDay: z.boolean() }),
  z.object({ mode: z.literal("interval"), startsAt: z.string().datetime(), endsAt: z.string().datetime(), allDay: z.boolean() }),
  z.object({ mode: z.literal("window"), earliestStartsAt: z.string().datetime().optional(), latestEndsAt: z.string().datetime() }),
]);

export const CalendarProjectionItemSchema = z.object({
  id: z.string().min(1).max(256),
  sourceApp: AppKeySchema,
  sourceEntityType: z.string().min(1).max(128),
  sourceEntityId: z.string().min(1).max(256),
  title: z.string().trim().min(1).max(512),
  description: z.string().max(2_000).optional(),
  placement: CalendarProjectionPlacementSchema,
  presentation: z.enum(["block", "marker", "context"]),
  occupancy: z.enum(["busy", "free"]),
  flexibility: z.enum(["fixed", "flexible"]),
  lifecycle: z.enum(["active", "completed", "cancelled", "archived"]),
  visibleFrom: z.string().datetime().optional(),
  projectId: z.string().max(256).optional(),
  projectLabel: z.string().max(512).optional(),
  color: z.string().regex(/^#[0-9a-f]{6}$/i).optional(),
  updatedAt: z.string().datetime(),
});

export const CalendarProjectionListSchema = z.array(CalendarProjectionItemSchema);

export type CalendarProjectionItem = z.infer<typeof CalendarProjectionItemSchema>;
export type CalendarProjectionPlacement = z.infer<typeof CalendarProjectionPlacementSchema>;
